// extracted by mini-css-extract-plugin
module.exports = {"container":"MHistory_container__2PWC9","table":"MHistory_table__kbg_L"};